import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { PermissionCheck } from "../../shared/permission";
import { UserDataProvider } from "../../data-provider/user.dp";
import { ToastUtils } from "../../helper/toast.helper";

let UserPaneComponent = {
    selector: "vcUserPane",
    templateUrl: "/angular/components/user/user-pane.component.html",
    bindings: {
        user: "=",
        inDialog: "=",
        updateUser: "&",
        deleteUser: "&",
        link: "=",
        backOrClose: "@",
    },
    controller: class UserPaneController {
        // * bindings for typescript compiler *
        public user: any;
        public inDialog: any;
        public updateUser: any;
        public deleteUser: any;
        public link: any;
        public backOrClose: string = "back";
        // ************************************

        private __env: any;
        private __app_type: string;
        private campaignDataProvider: CampaignDataProvider;
        private dataProvider: UserDataProvider;
        private toast: ToastUtils;
        private $window: any;

        public permissionProvider: PermissionCheck;
        public signedInUser: any;
        public isLeaderView: boolean;

        constructor(
            $window: any,
            __env: any,
            __app_type: string,
            CampaignDataProvider: CampaignDataProvider,
            UserDataProvider: UserDataProvider,
            PermissionCheck: PermissionCheck,
            ToastUtils: ToastUtils
        ) {
            this.__env = __env;
            this.__app_type = __app_type;
            this.campaignDataProvider = CampaignDataProvider;
            this.dataProvider = UserDataProvider;
            this.permissionProvider = PermissionCheck;
            this.$window = $window;
            this.isLeaderView = this.__app_type == "LEADER";

            this.toast = ToastUtils;
            this.signedInUser = this.dataProvider.getActiveUser();
        }

        $onInit() {
            // If backOrClose wasn't passed in (or is empty), default to 'back'
            if (!this.backOrClose) {
                this.backOrClose = "back";
            }
        }

        changeLiveCampaign(campaign: Campaign): void {
            this.campaignDataProvider
                .changeLiveCampaign(campaign)
                .then(() => {
                    this.$window.location = "/";
                })
                .catch((error: any) => {
                    this.toast.error("You are not a user on this account");
                });
        }

        deselectUser(user: any): void {
            user.show = false;
            user = null;
        }
    },
};

angular.module("user").component(UserPaneComponent.selector, UserPaneComponent);
